import React from "react";
import { Link } from "react-router-dom";

const ThankYou = () => {
  return (
    <div className="page">
      <section className="survey-page">
        <h2>Thank You!</h2>
        <p>Your feedback has been submitted successfully.</p>

        <div style={{ marginTop: "20px" }}>
          <Link to="/download" replace className="btn btn-primary">
            Go Back to Home
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ThankYou;
